import { render, staticRenderFns } from "./ProcResultQuery.vue?vue&type=template&id=8918d3fc"
import script from "./ProcResultQuery.vue?vue&type=script&lang=js"
export * from "./ProcResultQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports